
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/addPreset/addSection/components/addSectionCategoryHeader.scss.css.virtualfile';
        module.exports = {"addSectionCategoryHeader":"_addSectionCategoryHeader_1x7sf_7"};